import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import IndexController from 'cio/pods/imports/import/index/controller';
import ImportModel from 'cio/models/import';

export default class IndexRoute extends Route {
  setupController(controller: IndexController, model: ImportModel, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.importUrl.perform();
  }

  resetController(controller: IndexController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    controller.setProperties({
      isNewImport: false,
      useImportOption: undefined,
      newBroadcastName: undefined,
      newCampaignName: undefined,
      newCampaignTags: [],
      newCampaignDescription: undefined,
      isAddingAudience: false,
    });
  }
}
